import React, {useEffect, useState} from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  IconButton
} from '@material-ui/core/';


import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

//icons
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';

import fetchAPI from "../../../../components/utils/fetchAPI";

//styles
import { withStyles } from "@material-ui/core/styles";
import { Skeleton } from '@material-ui/lab';
import { Box, Collapse } from '@mui/material';
import runtimeEnv from "@mars/heroku-js-runtime-env";
import { MsalContext } from "@azure/msal-react";
import DialogHoneyLoad from '../DialogHoneyLoad/DialogHoneyLoad';

import './row.scss'

const env = runtimeEnv();

export default function Row(props) {
    const { row: rowProps, countryCode, showModalParts } = props;
    const [open, setOpen] = useState(false);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [row, setRow] = useState(rowProps);
    const [activeElement, setActiveElement] = useState(null);
    const [newDateEnd, setNewDateEnd] = useState(new Date())
    const [newDateStar, setNewDateStart] = useState(new Date())
    const [templeteDialog, setTempleteDialog] = useState(null)
    const [valueDatePick, setValueDatePick] = useState("")
    const updateModalState = () => {
      return setOpenModalConfirm(false);
    }

    const fetchUpdateDate = (value,batchs) => {  
        let serviceURL = env.REACT_APP_SERVICES_PUT_BATCH_EXCLUTIONS_RULES_SKU;
        serviceURL = serviceURL.replace("<countryCode>", countryCode);
        serviceURL = serviceURL.replace("<exclusionID>", batchs.id);

        let params = {
          mat_no: batchs.product,
          rules: batchs.rule,
          clients_exclusions: batchs.clients_exclusions,
          expDate: new Date(value).toLocaleDateString('en-US'),
        }        
  
        fetchAPI({
          protocol: "PUT",
          service: serviceURL,
          params: params,
          codeCountry : countryCode,
          callbackThen: (response) => {
            // this.setState({
            //   rowsSKUForModal: response,
            //   rowsForModal: response.accounts,
            // });
          },
        });
      }
    
    let handleDateChange = (e, element, index) => (value) => {
      if(e === "end"){
        let rows = row;
        element.expDate = value;
        rows[index] = element;
        setRow(rows);
        setNewDateEnd(value);
        setOpen(true);
        setValueDatePick(value)
        setOpenModalConfirm(true)
        setActiveElement({
          value,
          element
        })
      }else{
        setNewDateStart(value)
        setOpen(true);
      }
    };

    const onClickUpdate = (activeElement) => {
      fetchUpdateDate(activeElement.value, activeElement.element)
      setOpenModalConfirm(false)
    }
    const fecha = new Date();

    return (
      <React.Fragment>
        <DialogHoneyLoad
          opened={openModalConfirm}
          showIcon={true}
          iconType={"updating-clients"}
          message={"¿Estás seguro de cambiar la fecha de expiración?"}
          buttonCancel={true}
          buttonAccept={true}
          onClickCancel={updateModalState}
          onClickAccept={e => onClickUpdate(activeElement)}
        />
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
            <span
              style={{
                fontSize: "1rem"
              }}
            >
              {props.selectedCountryCode === "mdcolombia" ? row.product.substring(18, 13) : row.product.substring(18, 10)}
            </span>
            {/* </Link> */}
          </TableCell>
          <TableCell component="th" scope="row">
            {row.product_description}
          </TableCell>
          <TableCell align="left">{row.affectedAccounts}</TableCell>
          <TableCell align="left">
            {row.status === "expiration_bees_upload_success" || row.status === "bees_upload_success"
              ? `Exitoso`
              : row.status === "expiration_bees_upload_with_errors" || row.status === "Error" || row.status === "error" || row.status === "bees_upload_with_errors"
                ? `Error en Bees`
                : `Pendiente`
            }
          </TableCell>
          <TableCell align="left">
            {
              row.startDate ? (row.startDate.substring(8,10)+"/"+row.startDate.substring(5,7)+"/"+row.startDate.substring(0,4)) : " - "
            }
          </TableCell>
          <TableCell align="left">
            {
              row.expDate ? (row.expDate.substring(8,10)+"/"+row.expDate.substring(5,7)+"/"+row.expDate.substring(0,4)) : " - "
            }
          </TableCell>
          <TableCell align="left">
          { (row.startDate === null && row.expDate === null) || (new Date(row.startDate) <= fecha && row.expDate === null) || (new Date(row.startDate) <= fecha && new Date(row.expDate) > fecha)
                              ? "Activa"  
                              : "Desactiva"
                            }
          </TableCell>
          <TableCell align="left">
            {row.user_desc ? row.user_desc.clientEmail : " - "}
          </TableCell>
          <TableCell align="left">
            {
              row.updatedAt != null 
              && row.updatedAt != "Invalid date" 
              ? (row.updatedAt)
              : " - "
            }
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
            <Collapse in={row?.batchs ? open : ""} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>

                  </TableHead>
                  <TableBody>
                      {/* {subBodyTable(row.batchs)} */}
                      {row?.batchs?.map((element) => {
                        if(element.startDate && element.startDate.split('-').length > 1) {
                          element.startDate = element.startDate && element.startDate !== 'Invalid Date' ? (element.startDate.substring(8,10)+"/"+element.startDate.substring(5,7)+"/"+element.startDate.substring(0,4)) : null 
                          }
                        if(element.expDate &&  typeof element.expDate === 'string' && element.expDate.split('-').length > 1) {
                          element.expDate = element.expDate && element.expDate !== 'Invalid Date' ? (element.expDate.substring(5,7)+"/"+element.expDate.substring(8,10)+"/"+element.expDate.substring(0,4)) : null 
                          }
                      return element
                      }).map((element, index) => (
                        <>
                          <TableRow>
                            <TableCell align="left">
                              {''}
                            </TableCell>
                            <TableCell style={{paddingLeft:"91px", color: "#188FE4", paddingRight:"78px", cursor: "pointer", textDecoration: 'underline'}} onClick={e => props.todoModal(element.id, e,element.affectedAccounts)}>
                              { element.product_description }
                            </TableCell>
                            <TableCell  align="center">
                              {element.affectedAccounts ? element.affectedAccounts : "-"}
                            </TableCell>
                            <TableCell  align="right">
                              {element.status ? element.status : "-"}
                            </TableCell>
                            <TableCell align="right">
                              {element.startDate || "-"}
                            </TableCell>
                            <TableCell style={{display: "flex"}} align="left" >
                              <MuiPickersUtilsProvider
                                id="MuiPickerDataTable"
                                utils={DateFnsUtils}
                                style={{ justifyContent: "center"}}
                              >
                                <DatePicker
                                  id={"DatePickerDataTable"}
                                  autoOk
                                  variant="inline"
                                  // inputVariant="outlined"
                                  placeholder="Sin Fecha"
                                  // disableFuture // desactiva dias futuros
                                  //disablePast // desactiva dias pasados
                                  disableToolbar
                                  format="dd/MM/yyyy"
                                  // minDate={
                                  //  new Date().setDate(new Date().getDate() - 1)
                                  // }
                                  value={element.expDate}
                                  onChange={handleDateChange("end", element, index)}
                                  style={{fontSize: '14px !important',  width: '85px' }}
                                />
                              </MuiPickersUtilsProvider>
                              <EditIcon></EditIcon>
                            </TableCell>
                            <TableCell align="left">
                            { (element.startDate === null && element.expDate === null) || (new Date(element.startDate) <= fecha && element.expDate === null) || (new Date(element.startDate) <= fecha && new Date(element.expDate) > fecha)
                              ? "Activa"  
                              : "Desactiva"
                            }
                            </TableCell>
                            <TableCell align="left"> {/*usuario*/}
                              {element.user_email ? element.user_email : "-"}
                            </TableCell>
                            <TableCell align="left">
                              {element.updated_at ? new Date(element.updated_at.substring(3, 5) + "/" + element.updated_at.substring(0, 2) + "/" + element.updated_at.substring(6)).toLocaleDateString() : "-"}
                            </TableCell>
                            <TableCell>
                              {showModalParts(element.id, element.totalAcc)}
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
        {templeteDialog}
      </React.Fragment>
    );
  }
